module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcBAMAAACAI8KnAAAAMFBMVEUAAACampqYmJiXl5eZmZmXl5eXl5eYmJiYmJicnJyampqbm5unp6f///+ZmZmXl5cJG8Y6AAAAEHRSTlMAQdnKherzvlQxJiEMAWtsfamgeAAAAIlJREFUGNNjAAFOd7WkkgkMUMCh5LjmlIhSA4THbSwAohiNN4C5om8hwvcCwaIgEiIOUrVVAMZljAYSdgxw8BhorC2Ce7mBgUkAwWVUYJjEgAQ0GVyQeEBOITJXnEELmbuIIQeZewyNi6YYzSg0i9CcgeZINC+gePAzmvfRAgc16NACFiPY0SIFAGVzIFdjdnLTAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/popup_gouxuan_gray_mobile.png
// module id = RJlG
// module chunks = 64